module.exports = __webpack_public_path__ + "static/kinski-uncut-4d069d9624e28e8561166e4951a3e0fd.jpg";